import { render } from "./PropertyRegistrationModal.vue?vue&type=template&id=14bc312c&scoped=true"
import script from "./PropertyRegistrationModal.vue?vue&type=script&lang=js"
export * from "./PropertyRegistrationModal.vue?vue&type=script&lang=js"

import "./PropertyRegistrationModal.vue?vue&type=style&index=0&id=14bc312c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bc312c"]])

export default __exports__